import { Link, Navigate } from "react-router-dom";
import React from "react";
import { useDisclosure } from "@chakra-ui/react";
import {
  Container,
  Box,
  IconButton,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  ModalFooter,
} from "@chakra-ui/react";
import { Button, Modal, ModalOverlay } from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import bgImage from "../BackgroundVideo/Gymwolf_video.mp4";
import Login from "../Pages/Login";
import Register from "../Pages/Register";

function Navbar() {
  return (
    <>
    
      <Container
        maxW="full"
        style={{
          paddingTop: "15px",
          paddingBottom: "15px",
          backgroundColor: "rgba(0,0,0, 0.30)",
          fontFamily: "sans-serif",
          // border : "2px solid red"
        }}
      >
        <div
          style={{
            width: "80%",
            margin: "auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            color: "white",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <Link path="/" to="/">
              <img
                style={{ width: "145px" }}
                src="	https://www.gymwolf.com/img/gymwolf.png"
                alt="logo"
              />
            </Link>
          </div>
          <div
            style={{
              display: "flex",
              gap: "30px",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "18px",
            }}
          >
            {/* <Link path="/Register" to="/Register">
              Register
            </Link> */}
            <Register />

            <Login />

            <IconButton
              colorScheme="none"
              backgroundColor="none"
              color="white"
              aria-label="Search database"
              icon={<SearchIcon />}
            />
          </div>
        </div>
      </Container>
      <Container minW="full" padding="0px">
        <video style={{ height: "100vh" }} autoPlay muted loop>
          <source src={bgImage} type="video/mp4" />
        </video>
      </Container>
    </>
  );
}
export default Navbar;
